import { styled } from '@mui/system';
import {
  TextField,
} from '@mui/material';

export const TextFieldBase = styled(TextField)(() => ({
    bgcolor: 'black',
    input: { color: 'white' },
    '& .MuiOutlinedInput-root': {
        '& fieldset': { borderColor: 'white' },
        '&:hover fieldset': { borderColor: 'white' },
        '&.Mui-focused fieldset': { borderColor: 'white' },
    },
    '& .MuiInputAdornment-root svg': { color: 'white' },
}));


      